const APPLICATION_PARAMS = "/:applicationType/:applicationMode";
const LAUNCHPAGE_ROOT = "https://beta.novascotia.ca";

export const ROUTE_PATH = {
    PRIVACY_NOTICE: APPLICATION_PARAMS + "/privacy-notice",
    ELIGIBILITY_CONFIRMATION: APPLICATION_PARAMS + "/eligibility-confirmation",
    NOT_ELIGIBLE: APPLICATION_PARAMS + "/not-eligible",
    NS_LOGIN: APPLICATION_PARAMS + "/ns-login",
    WELCOME: APPLICATION_PARAMS + "/application-start-welcome",
    RJSC_SEARCH: APPLICATION_PARAMS + "/find-your-business",
    RJSC_COMPANY_DETAIL: APPLICATION_PARAMS + "/company-detail",
    RJSC_COMPANY_INFO: APPLICATION_PARAMS + "/company-info",
    RJSC_COMPANY_OFFICIALS: APPLICATION_PARAMS + "/company-officials",
    RJSC_SEARCH_SELECT: APPLICATION_PARAMS + "/business-select",
    RJSC_OPERATING_NAME_SEARCH_SELECT:
      APPLICATION_PARAMS + "/operating-business-select",
    RJSC_DETAIL_REVIEW: APPLICATION_PARAMS + "/review-business-info",
    RJSC_DETAIL_RENEW_REVIEW: APPLICATION_PARAMS + "/previous-rjsc-review",
    COMPANY_TRADEMARK: APPLICATION_PARAMS + "/company-trademark",
    BUSINESS_CONTACT: APPLICATION_PARAMS + "/business-contact-detail",
    ADDRESS_FOR_SERVICE: APPLICATION_PARAMS + "/address-for-service",
    FINANCIAL_RECORDS_LOCATION:
      APPLICATION_PARAMS + "/financial-records-location",
    LICENCE_HISTORY_QUESTION: APPLICATION_PARAMS + "/licence-history-ques",
    LICENCE_HISTORY_DETAILS: APPLICATION_PARAMS + "/licence-history-details",
    CRIMINAL_HISTORY_QUESTION: APPLICATION_PARAMS + "/criminal-history-ques",
    CRIMINAL_HISTORY_DETAILS: APPLICATION_PARAMS + "/criminal-history-details",
    WORK_HISTORY_DETAILS: APPLICATION_PARAMS + "/work-history-details",
    LICENCE_SUSPENSION_QUESTION: APPLICATION_PARAMS + "/licence-suspension-ques",
    LICENCE_SUSPENSION_DETAILS:
      APPLICATION_PARAMS + "/licence-suspension-details",
    ADDITIONAL_BRANCH_QUESTION: APPLICATION_PARAMS + "/additional-branch-ques",
    ADDITIONAL_BRANCH_DETAILS: APPLICATION_PARAMS + "/additional-branch-details",
    CURRENT_BRANCH_DETAILS: APPLICATION_PARAMS + "/branch-details", 
    NEW_BRANCH_APPLICATION_DETAILS: APPLICATION_PARAMS + "/new-branch-application-details",
    BRANCH_APPLICATION_REVIEW: APPLICATION_PARAMS + "/new-branch-application-review",
    BRANCH_APPLICATION_PAYMENT_CONFIRMATION: APPLICATION_PARAMS + "/branch-application-payment-confirmation",
    SUPPORTING_DOCUMENTS: APPLICATION_PARAMS + "/supporting-documents",
    TRUST_ACCOUNT: APPLICATION_PARAMS + "/trust-account",
    SURETY_BOND: APPLICATION_PARAMS + "/surety-bond",
    APPLICATION_REVIEW: APPLICATION_PARAMS + "/application-review",
    APPLICATION_RENEWAL_REVIEW: APPLICATION_PARAMS + "/application-renewal-review",
    ADDITIONAL_COLLECTOR_QUESTION:
      APPLICATION_PARAMS + "/additional-collector-question",
    COLLECTORS_REVIEW: APPLICATION_PARAMS + "/collectors_review",
    COLLECTOR_BEFORE_START: APPLICATION_PARAMS + "/collector_before_start",
    COLLECTOR_DETAILS: APPLICATION_PARAMS + "/collector_details",
    AGENT_DETAILS: APPLICATION_PARAMS + "/agent_details",
    COLLECTOR_LICENCE_HISTORY: APPLICATION_PARAMS + "/collector_licence_history",
    COLLECTOR_APPLICATION_REVIEW:
      APPLICATION_PARAMS + "/collector_application_review",
    CONFIRM_BEFORE_PAYMENT: APPLICATION_PARAMS + "/confirm-before-payment",
    PAYMENT_PREVIEW: APPLICATION_PARAMS + "/payment-preview",
    CONFIRM_APPLICATION_SUBMISSION:
      APPLICATION_PARAMS + "/confirm-app-submission",
    AGENCY_CHANGE_REQUEST: APPLICATION_PARAMS + "/change-request",
    LAUNCHPAGE_COLLECTION_AGENCY: LAUNCHPAGE_ROOT + "/collection-agency-licence",
    LAUNCHPAGE_DEBT_MANAGEMENT_AGENCY:
      LAUNCHPAGE_ROOT + "/debt-management-agency-licence",
    LAUNCHPAGE_COLLECTOR: LAUNCHPAGE_ROOT + "/collector-licence-individuals",
    LAUNCHPAGE_DEBT_MANAGEMENT_AGENT:
      LAUNCHPAGE_ROOT + "/debt-management-agent-licence",
    LAUNCHPAGE_MORTGAGE: LAUNCHPAGE_ROOT + "/mortgage-brokerage-licence",
    LAUNCHPAGE_LENDER : LAUNCHPAGE_ROOT + "/mortgage-lender-licence",
    LAUNCHPAGE_ADMINISTRATOR : LAUNCHPAGE_ROOT + "/mortgage-administrator-licence",
    BLT_LOGIN: "/admin-login",
    BLT_HOME: "/admin/home",
    BLT_REVIEW: "/admin/review/:qItemId",
    BLT_CHANGE_REVIEW: "/admin/change-review/:qItemId",
    BLT_DETAILS: "/admin/details",
    BLT_DECISION_SUMMARY: "/admin/decision/:status",
    BLT_LICENCE_INFORMATION: "/admin/information/:qItemId/:tabKey",
    BLT_HOME_SEARCH: "/admin/home/search",
    LAUNCHPAGE: "/",
  
    MRA_APP: "/mra",
    MRA_PRIVACY_NOTICE: "/privacy-notice",
    MRA_COMPLETED_REG_PROGRAM_QUESTION: "/completed-reg-program-question",
    MRA_COMPLETED_REG_PROGRAM_QUESTION_NO: "/completed-reg-program-question-no",
    MRA_PRINCIPAL_BROKER: "/principal-broker",
    MRA_PRINCIPAL_BROKER_NO: "/principal-broker-no",
    MRA_HAS_ROLE_WITH_RJSC: "/has-role-rjsc",
    MRA_HAS_ROLE_WITH_RJSC_NO: "/has-role-rjsc-no",
    MRA_HAS_WORK_EXPERIENCE: "/has-work-experience",
    MRA_HAS_WORK_EXPERIENCE_NO: "/has-work-experience-no",
    MRA_IS_CANADA_RESIDENT: "/is-canada-resident",
    MRA_IS_CANADA_RESIDENT_NO: "/is-canada-resident-no",
    MRA_IS_NINETEEN: "/is-nineteen",
    MRA_IS_NINETEEN_NO: "/is-nineteen-no",
    MRA_APPLY_FOR_MORTGAGE_LICENCE: "/mra-apply-for-mortgage-licence",
    
    MRA_MAIN_AGENT_CHANGE_REQUEST_REASON: "/mra-main-agent-change-reason",
    MRA_MAIN_AGENT_CHANGE_REQUEST_NEW_EMAIL: "/mra-main-agent-change-new-email",
    MRA_MAIN_AGENT_CHANGE_REQUEST_REVIEW: "/mra-main-agent-change-review",
    MRA_MAIN_AGENT_CHANGE_REQUEST_SUBMIT_CONFIRM: "/mra-main-agent-change-submitted",
    MRA_FILE_UPLOAD_VIEW: "/mra-file-upload-view",
  
    // renewal types
    MRA_RENEWAL_CONFIRM_PB: "/mra-renew-confirm-pb",
    MRA_RENEWAL_CONTENT_AWARENESS : "/mra-renew-content-awarness",
    MRA_RENEWAL_CONFIRM_AIR_SUBMISSION : "/mra-renew-confirm-air-submission",
    MRA_RENEWAL_CONFIRM_COMPANY_TYPE_SUBMISSION : "/mra-renew-confirm-company-type-submission",
    MRA_RENEWAL_CONFIRM_COMPANY_FISCAL_DATE : "/mra-renew-confirm-company-fiscal-date",
    MRA_RENEWAL_CONFIRM_COMPANY_FINANCIAL_LOCATION : "/mra-renew-confirm-company-financial-location",
    MRA_RENEWAL_CONFIRM_APPOINTED_AGENT : "/mra-renew-confirm-company-appointed-agent",
    MRA_RENEWAL_CONFIRM_INSURANCE_PROOF : "/mra-renew-confirm-insurance-proof",
    MRA_RENEWAL_CONFIRM_CRIMINAL_RECORD_CHECK : "/mra-renew-confirm-criminal-record-check",
    MRA_RENEWAL_APPLICATION_REVIEW : "/mra-renew-application-review",
    MRA_RENEWAL_CONFIRM_BEFORE_PAYMENT : "/mra-renew-confirm-before-payment",
    MRA_RENEWAL_PAYMENT_REVIEW : "/mra-renew-payment-review",
    MRA_RENEWAL_PAYMENT_CONFIRMATION : "/mra-renew-payment-confirm",
    MRA_RENEWAL_BROKER_CONTACT_INFORMATION : "/mra-renew-broker-contact",
    MRA_RENEWAL_CONFIRM_PRINCIPAL_BROKER_QUALIFICATION : "/mra-renew-confirm-pb-qualification",
    MRA_RENEWAL_CONFIRM_MORTGAGE_BROKER_QUALIFICATION : "/mra-renew-confirm-m-broker-qualification",
    MRA_RENEWAL_BROKER_EDUCATION_CERTIFICATE : "/mra-renew-broker-education-certificate",
    MRA_RENEWAL_PRINCIPAL_BROKER_ACT_REGULATION_CONFIRMATION : "/mra-renew-pb-act-regulation-confirmation",
    MRA_RENEWAL_BROKER_CRIMINAL_RECORD_CHECK: "/mra-renew-broker-crc",
    MRA_RENEWAL_BROKER_APPLICATION_REVIEW : "/mra-renew-broker-application-review",
  
    /* Step - 1 screens */
    MRA_RJSC_SEARCH: "/mra-rjsc-search",
    MRA_RJSC_SEARCH_SELECT: "/mra-business-select",
    MRA_RJSC_OPERATING_NAME_SEARCH_SELECT: "/mra-operating-business-select",
    MRA_RJSC_DETAIL_REVIEW: "/mra-review-business-info",
    MRA_RJSC_COMPANY_DETAIL: "/mra-company-detail",
    MRA_RJSC_COMPANY_INFO: "/mra-company-info",
    MRA_RJSC_COMPANY_OFFICIALS: "/mra-company-officials",
  
    /* Step - 2 screens */
    MRA_SELECT_PRINCIPAL_BROKER_FROM_LIST: "/mra-select-principal-broker",
    MRA_PRINCIPAL_BROKER_OR_BROKERAGE: "/mra-principal-broker",
    MRA_PREVIOUSLY_LICENCED_MORTGAGE_BROKER:
      "/previously-licenced-mortgage-broker",
    MRA_LICENCE_NUMBER: "/licence-number",
    MRA_BROKER_LICENCE_IN_PROVINCES: "/mortgage-broker-licence-in-provinces",
    MRA_BROKERAGE_INFO: "/mra-brokerage-info",
    MRA_HAS_COMPLETETED_EDUCATION: "/mra-has-completed-education",
    MRA_HAS_CERTIFICATE_NOVASCOTIA: "/mra-has-certificate-novascotia",
    MRA_COMPLETE_BROKER_EDUCATION: "/mra-complete-broker-education",
    MRA_UPLOAD_CERTIFICATE_EDUCATION: "/mra-upload-certificate-education",
    MRA_PRINCIPAL_BROKER_UPLOAD_CERTIFICATE_EDUCATION: "/mra-pb-upload-certificate-education",
    MRA_BROKER_CONTACT_INFORMATION: "/mra-broker-contact-information",
    MRA_CONFIRM_COMPLETION_REGULATORY_INFO:
      "/mra-confirm-completion-regulatory-info",
    MRA_CONFIRM_BUSINESS_INFO: "/mra-confirm-business-info",
    MRA_BROKER_APPLICATION_REVIEW: "/mra-broker-application-review",
    MRA_BROKER_NEXT_STEPS: "/mra-broker-next-steps",
    MRA_COMPANY_CONTACT_INFO: "/mra-company-contact-information",
    MRA_COMPANY_FINANCIAL_LOCATION: "/mra-company-financial-location",
    MRA_APPOINTED_AGENT_SERVICE_ADDRESS: "/mra-appointed-agent-service-address",
    MRA_COMPANY_FISCAL_END_DATE: "/mra-company-fiscal-end-date",
    MRA_UPLOAD_CRIMINAL_RECORD_CHECK: "/mra-upload-criminal-record-check",
    MRA_UPLOAD_CRIMINAL_RECORD_CHECK_AGENCY: "/mra-upload-criminal-record-check-agency",
    MRA_UPLOAD_PROOF_OF_INSURANCE: "/mra-upload-proof-of-insurance",
    MRA_BROKER_CONFIRMATION: "/mra-broker-confirmation",
    MRA_BROKER_APPLICATION_COMPANY_REVEIW:
      "/mra-broker-application-company-review",
    MRA_ADD_BROKERS_TO_BROKERAGE: "/mra-add-brokers-to-brokerage",
    MRA_UPLOAD_WORK_HISTORY: "/mra-upload-work-history",
    MRA_PAYMENT_CONFIRMATION: "/mra-payment-confirmation",
    MRA_PRINCIPAL_BROKER_INELIGIBLE: "/mra-principal-broker-ineligible",
    MRA_RENEWAL_BROKER_CONTINUING_EDUCATION_CONFIRMATION: "/mra-education-continuing-confirmation",
    MRA_RENEWAL_BROKER_CONTINUING_EDUCATION_CERTIFICATE: "/mra-education-continuing-certificate",
  
    /* Add new principal broker or compliance officer application */
    MRA_ADD_MAIN_AGENT_REGULATORY_INFO_CONFIRMATION: "/regulatory-info-confirmation",
    MRA_ADD_MAIN_AGENT_ROLE_CONFIRMATION : "/role-confirmation",
    MRA_ADD_MAIN_AGENT_RESPONSIBILITY_CONFIRMATION : "/responsibility-confirmation",
    MRA_ADD_MAIN_AGENT_WORK_EXPERIENCE_CONFIRMATION : "/work-exp-confirmation",
    MRA_ADD_MAIN_AGENT_RESIDENCY_CONFIRMATION : "/residency-confirmation",
    MRA_ADD_MAIN_AGENT_AGE_CONFIRMATION : "/age-confirmation",
    MRA_ADD_MAIN_AGENT_LICENCE_TYPE_SELECTION : "/licence-type-selection",
    MRA_ADD_MAIN_AGENT_LICENCE_IN_OTHER_PROVINCE : "/licence-in-other-province",
    MRA_ADD_MAIN_AGENT_UPLOAD_WORK_HISTORY : "/upload-work-history",
    MRA_ADD_MAIN_AGENT_LICENCE_NUMBER : "/licence-number",
    MRA_ADD_MAIN_AGENT_BROKER_INFORMATION : "/broker-information",
    MRA_ADD_MAIN_AGENT_SELECT_OFFICER : "/select-officer",
    MRA_ADD_MAIN_AGENT_ACTIVE_LICENCE_CONFIRMATION : "/active-licence-confirmation",
    MRA_ADD_MAIN_AGENT_CURRENT_MRA_NUMBER : "/current-mra-number",
    MRA_ADD_MAIN_AGENT_CONTACT_INFORMATION : "/contact-information",
    MRA_ADD_MAIN_AGENT_AGENT_DUTIES_CONFIRMATION : "/duties-confirmation",
    MRA_ADD_COMPLIANCE_OFFICER_DUTIES_CONFIRMATION : "/compliance-officer-duties-confirmation",
    MRA_ADD_MAIN_AGENT_APPLICATION_SUBMITTED : "/application-submitted",
    MRA_ADD_MAIN_AGENT_COURSE_CERTIFICATE_UPLOAD: "/course-certificate-upload",
    MRA_ADD_MAIN_AGENT_CRIMINAL_RECORD_DOCUMENT_UPLOAD: "/criminal-record-upload",
    MRA_ADD_MAIN_AGENT_CONFIRM_COMPLETION_REGULATORY_INFO: "/confirm-completion-regulatory-info",
    MRA_ADD_MAIN_AGENT_CONFIRM_CURRENT_NS_LICENCE_NUMBER : "/confirm-current-ns-licence",
    MRA_ADD_MAIN_AGENT_CURRENT_NS_LICENCE_NUMBER : "/current-ns-licence",
    MRA_ADD_MAIN_AGENT_APPLICATION_REVIEW : "/application-review",
    MRA_ADD_MAIN_AGENT_PAYMENT_PREVIEW : "/payment-preview",
  
    /* step - 4 screens */
    MRA_PAYMENT_PREVIEW: "/mra-payment-preview",
  
    MRA_ASSOCIATE_BEFORE_YOU_START: "/mra-broker-associate/before-you-start",
    MRA_ASSOCIATE_APPLICANT_INFO: "/mra-broker-associate/applicant-information",
    // MRA_ASSOCIATE_RECOMMENDED_LICENCE: "/mra-broker-associate/recommeded-licence",
    MRA_ASSOCIATE_CONFIRMATION: "/mra-broker-associate/confirmation",
    MRA_ASSOCIATE_CONTINUE_APPLICATION: "/mra-broker-associate/continue-application",
    MRA_ASSOCIATE_HAS_EDUCATION: "/mra-broker-associate/associate-has-education",
    MRA_ASSOCIATE_NOT_HAS_CERTIFICATE: "/mra-broker-associate/associate-not-has-certificate",
    MRA_ASSOCIATE_UPLOAD_CERTIFICATE_COMPLETION: "/mra-broker-associate/associate-upload-certificate",
    MRA_ASSOCIATE_BROKER_LICENCE_INFO: "/mra-broker-associate/associate-broker-licence-info",
    MRA_ASSOCIATE_HAS_LICENCE_IN_PROVICES: "/mra-broker-associate/associate-licence-in-provices",
    MRA_ASSOCIATE_NOT_HAS_COURSE: "/mra-broker-associate/associate-not-has-course",
    MRA_CURRENTLY_BROKER_IN_NS: "/mra-currently-broker-in-ns",
    MRA_CURRENT_APPLICANT_LICENCE_NUMBER: "/mra-current-applicant-licence-number",
  
    /* New app mortgage lender */
    ML_APP: "/ml",
    ML_PRIVACY_NOTICE: "/privacy-notice",
    ML_IS_COMPLIANCE_OFFICER: "/is-compliance-officer",
    ML_IS_COMPLIANCE_OFFICER_NO: "/is-compliance-officer-no",
    ML_HAS_ROLE_WITH_RJSC: "/has-role-rjsc",
    ML_CHOOSE_NEW_COMPLIANCE_OFFICER: "/choose-new-compliance-officer",
    ML_IS_RESIDENT_CANADA: "/is-resident-canada",
    ML_IS_RESIDENT_CANADA_NO: "/is-resident-canada-no",
    ML_IS_NINETEEN: "/is-nineteen",
    ML_IS_NINETEEN_NO: "/is-nineteen-no", 
    ML_APPLY_LENDER_LICENCE: "/apply-for-lender-licence",
    ML_NEXT_STEPS: "/next-steps",
    ML_PAYMENT_PREVIEW : "/payment-preview",
    ML_PAYMENT_CONFIRMATION : "/payment-confirmation",
    /* ML and MA - Renewal */
    RENEWAL_SELECT_LENDER: "/renewal-select-lender",
    RENEWAL_COMPLIANCE_OFFICER : "/renewal-compliance-officer",
    RENEWAL_COMPLIANCE_OFFICER_QUALIFICATION : "/renewal-co-qualification",
    RENEWAL_REGULATION_ACT : "/renewal-regulation-act",
    RENEWAL_AIR_SUBMISSION : "/renewal-air-submission",
    RENEWAL_FINANCIAL_STATEMENT_SUBMISSION : "/renewal-financial-statement-submission",
    RENEWAL_COMPANY_TYPE : "/renewal-company-type",
    RENEWAL_COMPANY_FISCAL_END_DATE : "/renewal-company-fiscal-end-date",
    RENEWAL_COMPANY_FINANCIAL_RECORDS_LOCATION : "/renewal-company-financial-records-location",
    RENEWAL_APPOINTED_AGENT_SERVICE_ADDRESS : "/renewal-appointed-agent-service-address",
    RENEWAL_PROOF_OF_INSURANCE : "/renewal-proof-of-insurance",
    RENEWAL_CRIMINAL_RECORD_CHECK : "/renewal-criminal-record-check",
    RENEWAL_TRUST_ACCOUNT: "/renewal-trust-account",
    RENEWAL_APPLICATION_REVIEW : "/renewal-application-review",
    RENEWAL_CONFIRMATION_BEFORE_PAYMENT : "/renewal-confirm-before-payment",
    RENEWAL_PAYMENT_PREVIEW : "/renewal-payment-preview",
    RENEWAL_PAYMENT_CONFIRMATION : "/renewal-payment-confirmation",
  
     /* Step - 1 screens */
     ML_RJSC_SEARCH: "/rjsc-search",
     ML_RJSC_SEARCH_SELECT: "/business-select",
     ML_RJSC_OPERATING_NAME_SEARCH_SELECT: "/operating-business-select",
     ML_RJSC_DETAIL_REVIEW: "/review-business-info",
     ML_RJSC_COMPANY_DETAIL: "/company-detail",
     ML_RJSC_COMPANY_INFO: "/company-info",
     ML_RJSC_COMPANY_OFFICIALS: "/company-officials",
     ML_SELECT_COMPANY_TYPE: "/select-company-type",
     ML_IS_BUSINESS_INCORPORATED: "/is-business-incorporated",
     ML_BUSINESS_NOT_ELIGIBLE: "/business-not-eligible",
     ML_IS_BUSINESS_UNDER_LAW: "/is-business-under-law",
  
     /* Step -2 screens */
     ML_SELECT_LENDER: "/select-lender",
     ML_LENDER_CONTACT_INFORMATION: "/lender-contact-information",
     ML_COMPANY_CONTACT_INFO: "/company-contact",
     ML_COMPANY_FINANCIAL_LOCATION: "/company-financial-location",
     ML_AGENT_ADDRESS: "/agent-address",
     ML_FISCAL_END_DATE: "/fiscal-end-date",
     ML_UPLOAD_CRIMINAL_RECORD_CHECK: "/upload-criminal-record-check",
     ML_UPLOAD_PROOF_OF_INSURANCE: "/upload-proof-of-insurance",
     ML_CONFIRMATION: "/confirmation",
     ML_APPLICATION_REVIEW: "/application-review",
  
     /* Mortgage Admin Startup screens */
     MA_APP: "/ma",
     MA_PRIVACY_NOTICE: "/privacy-notice",
     MA_APPLY_ADMIN_LICENCE: "/apply-for-administrator-licence",
     MA_IS_COMPLIANCE_OFFICER: "/is-compliance-officer",
     MA_IS_COMPLIANCE_OFFICER_NO: "/is-compliance-officer-no",
     MA_HAS_ROLE_WITH_RJSC: "/has-role-rjsc",
     MA_CHOOSE_NEW_COMPLIANCE_OFFICER: "/choose-new-compliance-officer",
     MA_IS_RESIDENT_CANADA: "/is-resident-canada",
     MA_IS_RESIDENT_CANADA_NO: "/is-resident-canada-no",
     MA_IS_NINETEEN: "/is-nineteen",
     MA_IS_NINETEEN_NO: "/is-nineteen-no", 
     MA_SELECT_COMPANY_TYPE: "/select-company-type",
     MA_IS_BUSINESS_INCORPORATED: "/is-business-incorporated",
     MA_BUSINESS_NOT_ELIGIBLE: "/business-not-eligible",
     MA_IS_BUSINESS_UNDER_LAW: "/is-business-under-law",
     MA_TRUST_ACCOUNT: "/trust-account",
     MA_SURETY_BOND: "/surety-bond",
  
     PB_APP: "/principal-broker",
     CO_APP: "/compliance-officer",
  
     /* */
     MRA_DETAILS: "/mra_details",
     MRA_DETAILS_LIST : "/list",
     BROKER_DETAILS_LIST : "/brokers"
  };

  //https://collectionagencyui-collectionagency-dev.apps.nonprod.novascotia.ca/
const SERVER_URL = "/api";
export const RJSC_SERVICE_URL = SERVER_URL + "/rjsc/entities";
export const RJSC_USERNAME = "collectionDevUser";
export const RJSC_PWD = "collectionDevPassword";
export const RJSC_PAGE_LINK = "https://rjsc.novascotia.ca/";
export const RJSC_UPDATE_LINK = "https://rjsc.novascotia.ca/login";
export const COMPANY_TRADEMARK_HOME_LINK = "https://www.ic.gc.ca/app/opic-cipo/trdmrks/srch/home"
export const MRA_REGULATION_ACT_DOCUMENT_LINK = "https://nslegislature.ca/sites/default/files/legc/statutes/mortgage%20regulation.pdf"
export const MRA_REGULATION_JUSTICE_LINK = "https://novascotia.ca/just/regulations/rxam-z.htm#mortgreg"

export const SAVE_APPLICATION_DATA_URL = SERVER_URL + "/application";
export const APPROVE_AND_CANCEL_APPLICATION_URL = SERVER_URL + "/application/transfer-licence";
export const SAVE_APPLICATION_STATUS_URL = SERVER_URL + "/application/status";
export const SAVE_LICENCE_STATUS_URL = SERVER_URL + "/licence/status";
export const APPLICATION_REFERENCE_DATA_URL = SERVER_URL + "/referencedata";
export const FETCH_APPLICATIONS_URL = SERVER_URL + "/applications";
export const FETCH_ARCHIVE_APPLICATIONS_URL = SERVER_URL + "/archive_applications";
export const ARCHIVE_ALL_APPLICATIONS_URL = SERVER_URL + "/archive_all";
export const FETCH_ADMIN_QUEUE_URL_LOCAL_TESTING = SERVER_URL + "/applicationsQueue";
export const FETCH_BRANCHES_URL = SERVER_URL + "/applications";
export const FETCH_APPLICATION_URL = SERVER_URL + "/application";
export const FETCH_APPLICATION_TRANSACTIONS_URL = SERVER_URL + "/transactions";
export const BUSINESS_LICENCE_QUEUE_SAMPLE_URL =
  "/businessLicenceQueueSample.json";
export const LOGIN_URL = "/saml2/authenticate/nsid";
export const LOGOUT_URL = "/logout";
export const ACCOUNT_INFO_URL = SERVER_URL + "/account";
export const TOKEN_URL = SERVER_URL + "/token";
export const PAYMENT_URL = SERVER_URL + "/pay/request";
export const DOCUMENT_FETCH_URL = SERVER_URL + "/documents";
export const SEND_MESSAGE_URL = SERVER_URL + "/email";
export const ARCHIVE_APPLICATION_URL = SERVER_URL + "/archive_applications";
export const LICENCE_TYPE_DETAILS_URL = SERVER_URL + "/licenceTypeDetails";
export const RENEW_INDIVIDUAL_APPLICATIONS = SERVER_URL + "/renewIndividualApplications";
export const DO_NOT_RENEW_INIVIDUAL_APPLICATIONS = SERVER_URL + "/doNotRenewIndividualApplications";
export const SYNC_RJSC_DETAILS_FOR_INDIVIDUAL_APPLICATIONS = SERVER_URL + "/syncRjscDetailsForIndividualApplications"
export const MARK_DELETE_APPLICATIONS = SERVER_URL + "/markDeleteApplications"
export const FETCH_ADMIN_QUEUE = SERVER_URL + "/applications_queue";
export const FETCH_BUSINESS_LICENCE_PDF = SERVER_URL + "/pdf";
export const SEARCH_LOGIN_ID_URL = SERVER_URL + "/application/get-user-by-email";
export const CHANGE_PRINCIPAL_BROKER_URL = SERVER_URL + "/application/change-principal-broker";
export const CHANGE_COMPLIANCE_OFFICER_URL = SERVER_URL + "/application/change-compliance-officer";
export const CHECK_LICENCE_ACTIVE_URL = SERVER_URL + "/application/check_licence_active";


export const SEGUE_NAME = {
  LOGIN: "segue_login",
  LOGOUT: "segue_logout",
  PAYMENT: "segue_payment",
};
